import Main from '../index'

export default {
  install (Vue, options = {}) {
    const Picker = Vue.extend(Main)
    function $batchLabel (dataVal, callback) {
      console.log(dataVal, 'dataValdataValdataVal')
      const data = {
        ...options,
        dialogVisible: true,
        ...dataVal
      }

      return new Promise((reslove) => {
        const vm = new Picker({
          propsData: data,
          created () {
            const destory = () => {
              this.$destroy()
              this.$el.remove()
            }

            this.$once('changeDialogVisible', destory)
            this.$once('selectBabelList', (val) => {
              callback(val)
              this.$destroy()
              this.$el.remove()
            })
          }
        }).$mount()
        document.body.appendChild(vm.$el)
      })
    }

    Vue.prototype.$batchLabel = $batchLabel
  }
}
